import styled from "styled-components";
// import { Link } from "react-router";
// import { Icon } from "@iconify/react";



export const StyledMaineContentSection = styled.div`
/* background-color: red; */
/* width: 100%; */
height: 100vh;
display: flex;
flex-direction: column;
padding: 16px;
`

export const StyledContentDomesticPackageSection = styled.div`
/* background-color: green ; */
height: fit-content;
/* width: 100%; */
display: flex;
flex-direction: column;

`
export const StyledPackageHeadingAndAddButton = styled.div`
/* width: 100%; */
height: fit-content;
display: flex;
flex-direction: row;
justify-content: space-between;

`
export const StyledPackageHeadingText = styled.h4`
font-size: 18px;
font-weight: 600;
`

export const StyledPackageAddButton = styled.button`
width: fit-content;
/* height: fit-content; */
padding: 8px;
background-color: white;
color: #1877f2;
font-weight: bold;
border-radius: 10px;
border: none;
text-transform: capitalize;
box-shadow: 0 2px 6px rgba(0, 0, 0, 0.56);
transition: all 0.2s ease;
&:hover{
  cursor: pointer;
  color: white;
  background-color: #1877f2;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.45);

}
`
export const StyledPackageMapingSection = styled.div`
width: 100%;
height: fit-content;
display: flex;
flex-wrap: wrap;
gap: 10px;
padding-top: 8px;
padding-bottom: 8px;
/* background-color: aqua; */

`

export const StyledHoverIconsSection = styled.div`
width: fit-content;
padding: 4px;
display: flex;
flex-direction: row;
gap: 5px;

opacity: 0;
pointer-events: none;
transform:  translateY(10px);
transition: all 0.25s ease;


`
export const StyledPackageDiv = styled.div`
width: 280px;
/* height: 330px; */
background-color: white;
border-radius: 16px;
box-shadow: rgba(145, 158, 171, 0.08) 0px 0px 2px,rgba(145, 158, 171, 0.08) 0px 12px 24px -4px;

&:hover {
    box-shadow:
      rgba(145, 158, 171, 0.12) 0px 0px 4px,
      rgba(145, 158, 171, 0.16) 0px 16px 32px -4px;

    transform: translateY(-2px);
  }

&:hover ${StyledHoverIconsSection} {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}


`

export const StyledPackageImg = styled.img`
height: 160px;
width: 100%;
object-fit: cover;
border-radius: 16px 16px 0px 0px ;
`

export const StyledPackageDetailsSection = styled.div`
width: 100%;
height: fit-content;
padding: 15px;

`

export const StyledPackageDetailsMainTextNameandPrice = styled.h4`
font-size: 16px;
font-weight: 600;
color: black;
text-transform: capitalize;


`

export const StyledPackageOtherDetails = styled.p`
font-size: 13px;
color: #637380;
text-transform: capitalize;
`

export const StyledHoverIconsandPriceSection = styled.div`
width: 100%;
height: fit-content;
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
`

export const StyledVisibleIconButton = styled.button`
width: fit-content;
height: fit-content;
border-radius: 10px;
padding-inline: 6px;
padding-block: 4px;
background-color: white;
color: ${(p) => p.color};
border: none;
display: flex;
justify-content: center;
align-items: center;
box-shadow: 0 2px 6px rgba(0, 0, 0, 0.19);
transition: all 0.2s ease;
&:hover{
  cursor: pointer;
  color: white;
  background-color: ${(p) => p.color};
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);

}

`
/* Modal Section */


export const StyledAddPackagePopupSection = styled.div`
position: fixed;
inset: 0;
display: flex;
align-items: center;
justify-content: center;
background: rgba(0, 0, 0, 0.45);
z-index: 100;
`
export const StyledPackagePopup = styled.div`
width: 520px;
height: fit-content;
display: flex;
flex-direction: column;
background-color: white;
border-radius: 16px;
overflow-y: auto;
overflow-x: hidden;
`

export const StyledPackagePopupHeader = styled.div`
padding: 16px 20px;
display: flex;
flex-direction: row;
justify-content: space-between;
border-bottom: 1px solid #eee;
`

export const StyledPackageHeaderTitle = styled.h4`
font-size: 18px;
`

export const StyledPackageHeaderCloseIcon = styled.button`
border: none;
background-color: transparent;
cursor: pointer;

`

export const StyldePackageBodySection = styled.div`
padding: 20px;
flex: 1;
overflow-y: auto;
   /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #1877f2 transparent;

  /* Chrome / Edge / Safari */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #1877f2;
    border-radius: 10px;
  }

  /* Make arrows INVISIBLE (not removed) */
  &::-webkit-scrollbar-button {
    background: transparent;
    height: 0;
    width: 0;
  }

`

export const StyledPackageBodyGrid = styled.div`
display: grid;
grid-template-columns: 1fr 1fr;
gap: 14px;
`
export const StyledPackageName = styled.input`

`
export const StyldePackageType = styled.select`

`
export const StyedPackageDestination = styled.input`

`
export const StyledPackageDuration = styled.input`

`
export const StyledPackagePrice = styled.input`

`
export const StyledPackageFooterSection = styled.div`

`
export const StyledPackageCancelButton = styled.button`

`
export const StyledPackageAddPackageButton = styled.button`

`
export const StyledContentInternationalPackageSection = styled.div`
/* background-color: yellow; */
height: 300px;
width: 100%;
`